import React, { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import { BASE_URL_APISERVICES, BASE_URL_PAYNOW } from "../../utils/Constants";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { twoDecimalPlaces } from "../../utils/utilFuctions";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
  dateFormatter,
  ExportToExcel,
  excelMapping,
} from "../../utils/utilFuctions";
import { offsetArr } from "../../utils/CommonConfig";
import "./DashboardData.css";
import { adminAuth, basicAuth } from "../../config";
function ReconDashboard() {
  const { username1, password1 } = adminAuth;
  const { username, password } = basicAuth;
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [reconData, setReconData] = useState([]);
  const [walletData, setWalletData] = useState([]);
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const [duplicateEntries, setDuplicateEntries] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(10);
  const [paynnowPayout, setPaynnowPayout] = useState(0);
  const [bumppypayPayout, setBumppypayPayout] = useState(0);

  const now = (date = new Date()) => {
    return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
      }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
  };

  const getDashboardReconData = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " +
        Buffer.from(username1 + ":" + password1).toString(
          "base64"
        )
      );
      var raw = JSON.stringify({
        adminId: user.pkid,
        date: dateFormatter(startDate),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_DASH_RECON_DATA}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.responseCode == "00") {
            setData(result.data);
            setDataToDisplay(result.data);
            setTransactionLoaderState(false);
          } else {
            setData([]);
            dataToDisplay([]);
            setTransactionLoaderState(false);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };

  const getPaynnowReport = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " +
        Buffer.from(username + ":" + password).toString(
          "base64"
        )
      );
      var raw = JSON.stringify({
        ttype: 1,
        fromDate: dateFormatter(startDate),
        toDate: dateFormatter(startDate),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_PAYNOW}${API_ENDPOINTS.TXN_REPORT}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (Array.isArray(result)) {
            let paynnowTotal = 0;

            result.forEach(txn => {
              paynnowTotal += Number(txn.transactionAmount);
              // console.log(txn);

            });

            setPaynnowPayout(paynnowTotal);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };

  const getDashboardReconDataCommissionAndCharg = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " +
        Buffer.from(username1 + ":" + password1).toString(
          "base64"
        )
      );
      var raw = JSON.stringify({
        adminId: user.pkid,
        // date: dateFormatter(startDate) 
        date: "2025-06-13" 
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_DASH_COMM_CHARGES}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.responseCode == "00") {
            setData(result.data);
            setTransactionLoaderState(false);
          } else {
            setData([]);
            setCardData([]);
            setTransactionLoaderState(false);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };

  const getDashboardReconDataServiceWise = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " +
        Buffer.from(username1 + ":" + password1).toString(
          "base64"
        )
      );
      var raw = JSON.stringify({
        adminId: user.pkid,
        // date: dateFormatter(startDate),
        date: "2025-06-13" 
        
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_DASH_COMM_CHARGES_SERVICE}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.responseCode == "00") {
            const data = result.data;

            let credit = 0, debit = 0, success_amount = 0, refund_amount = 0, ledgerViewAmount = 0, totalDifference = 0, bumppypayPayoutTotal = 0;

            const newData = data.map((item) => {

              if (item.service == "Total Payout") {
                bumppypayPayoutTotal = item.success_amount;
              }

              success_amount += (item.success_amount ? Number(item.success_amount) : 0);
              credit += (item.credit ? Number(item.credit) : 0);
              debit += (item.debit ? Number(item.debit) : 0);
              refund_amount += (item.refund_amount ? Number(item.refund_amount) : 0);
              ledgerViewAmount += (item.ledgerViewAmount ? Number(item.ledgerViewAmount) : 0);

              const difference = item.type == 1 ? (item.credit > 0 ? (item.success_amount - item.refund_amount - item.ledgerViewAmount) : (item.ledgerViewAmount - item.success_amount - item.refund_amount)) : 0;
              totalDifference += difference;
              return {
                ...item,
                difference: difference
              }
            });
            console.log(ledgerViewAmount);
            newData.push(
              {
                service: "Total",
                success_amount: success_amount,
                credit: credit,
                debit: debit,
                refund_amount: refund_amount,
                ledgerViewAmount: ledgerViewAmount,
                difference: totalDifference,
              },
            )

            setBumppypayPayout(bumppypayPayoutTotal)

            console.log(data);

            setData(newData);
            setServiceData(newData);
            setTransactionLoaderState(false);
          } else {
            setData([]);
            setServiceData([]);
            setTransactionLoaderState(false);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchVendorPaymentsReport = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " +
        Buffer.from(username1 + ":" + password1).toString(
          "base64"
        )
      );
      var raw = JSON.stringify({
        fromDate: dateFormatter(startDate),
        toDate: dateFormatter(endDate),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_DUPLICATE_LEDGER}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.responseCode == "00") {
            setDuplicateEntries(result.data);
            setTransactionLoaderState(false);
          } else {
            setData([]);
            setTransactionLoaderState(false);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };

  const getDashboardReconDataMaster = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " +
        Buffer.from(username1 + ":" + password1).toString(
          "base64"
        )
      );
      var raw = JSON.stringify({
        adminId: user.pkid,
        date: dateFormatter(startDate),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_DASH_RECON_DATA_MASTER}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.responseCode == "00") {
            setData(result.data);
            setReconData(result.data);
            setTransactionLoaderState(false);
          } else {
            setData([]);
            setReconData([]);
            setTransactionLoaderState(false);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = () => {
    fetchVendorPaymentsReport(startDate, endDate);
  };
  const positionStyle1 = {
    position: "absolute",
    top: -38,
    left: 0,
    fontFamily: "Poppins",
    color: "rgba(255, 255,255, 1)",
  };

  useEffect(() => {
    getDashboardReconData();
    getDashboardReconDataCommissionAndCharg();
    getDashboardReconDataServiceWise();
    fetchVendorPaymentsReport();
    getDashboardReconDataMaster();
    getPaynnowReport();
  }, []);

  return (
    <div>
      <div class="dashboard-container">
        <div class="summary-section">
          <div class="card">
            <h4 style={{ color: "#0E2148" }}>
              <b> Payout Overview</b>
            </h4>
            <div class="summary-grid">
              <div>
                <strong>Paynnow Payout</strong>
                <br />
                {paynnowPayout}
              </div>
              <div>
                <strong>Bumppypay Payout</strong>
                <br />
                {twoDecimalPlaces(bumppypayPayout)}
              </div>
              <div style={{
                color: ((paynnowPayout && bumppypayPayout) ? (paynnowPayout - bumppypayPayout) < 0 ? "#c0392b" : "#27ae60" : "#000000")
              }}>
                <strong>Difference</strong>
                <br />
                {(paynnowPayout && bumppypayPayout) ? (paynnowPayout - bumppypayPayout) : "0.0"}
              </div>
            </div>
          </div>

          <div class="card">
            <h4 style={{ color: "#0E2148" }}>
              <b>API Analytics</b>
            </h4>
            <div class="summary-grid">
              <div>
                <strong>Total Sales</strong>
                <br />
                40,569
              </div>
              <div>
                <strong>Purchase</strong>
                <br />
                154,220
              </div>
              <div>
                <strong>Expenses</strong>
                <br />
                10,041
              </div>
              <div>
                <strong>Credits</strong>
                <br />
                12,150
              </div>
            </div>
          </div>

          <div class="card">
            <h4 style={{ color: "#0E2148" }}>
              <b>TOP-UP OverView</b>
            </h4>
            <div class="summary-grid">
              <div>
                <strong>Invoiced</strong>
                <br />
                21,132
              </div>
              <div>
                <strong>Received</strong>
                <br />
                10,763
              </div>
              <div>
                <strong>Outstanding</strong>
                <br />
                8,041
              </div>
              <div>
                <strong>Overdue</strong>
                <br />
                45,897.01
              </div>
            </div>
          </div>
        </div>

        <div class="middle-section">
          <div class="left-panel">
            <div class="mini-card">
              {cardData.map((e, index) => (
                <div
                  key={index}
                  className="m-2"
                  style={{
                    flex: "1 1 calc(25% - 20px)",
                    backgroundColor: "#f8f9fc",
                    borderRadius: "16px",
                    padding: "20px",
                    minWidth: "260px",
                    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
                    color: "black",
                    fontFamily: "Poppins",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <div
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      marginBottom: "12px",
                      textAlign: "center",
                      textTransform: "uppercase",
                    }}
                  >
                    {e.type}
                  </div>

                  <div
                    style={{
                      fontSize: "14px",
                      marginBottom: "10px",
                      fontWeight: "500",
                    }}
                  >
                    <span style={{ fontWeight: "600" }}>Success Amount:</span> ₹
                    {twoDecimalPlaces(e.success_amount)}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    <div style={{ color: "#56f68e", fontWeight: "600" }}>
                      Credit: ₹{twoDecimalPlaces(e.credit)}
                    </div>
                    <div style={{ color: "#ff8b94", fontWeight: "600" }}>
                      Debit: ₹{twoDecimalPlaces(e.debit)}
                    </div>
                  </div>

                  <div
                    style={{
                      fontSize: "14px",
                      color: "black",
                      fontWeight: "600",
                      textAlign: "right",
                    }}
                  >
                    Date: {e.date}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div class="revenue-panel">
            {/* <div class="customers-panel"> */}
            <div>
              {reconData.length > 0 && (
                <div className="scroll-inner admin-fix-width borderless-table">
                  <table
                    className="my-table transparent-table text-center border-bottom"
                    style={{
                      width: "100%",
                      overflowX: "auto",
                      border: "0px",
                      overflow: "auto",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          colSpan={2}
                          style={{
                            backgroundColor: "#7F8CAA",
                            color: "#ffffff",
                            padding: "16px",
                            textAlign: "center",
                            borderRadius: "12px",
                            fontSize: "15px",
                            fontWeight: "500",
                          }}
                        >
                          Data Summary
                        </th>
                      </tr>
                   
                    </thead>
                    <tbody>
                      {reconData.map((e, index) => (
                        <tr
                          key={index}
                          className="border-bottom clickable-row"
                        >
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              textAlign: "center",
                            }}
                          >
                            {e.dataLabel}
                          </td>
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              textAlign: "center",
                              color:
                                parseFloat(e.dataValue) < 0
                                  ? "#c0392b"
                                  : "#27ae60",
                            }}
                          >
                            {twoDecimalPlaces(e.dataValue)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>

        <div class="middle-section mt-3">
          <div class="revenue-panel">
            <div class="customers-panel">
              <div>
                {serviceData.length > 0 && (
                  <div className=" scroll-inner admin-fix-width borderless-table ">
                    <table
                      className="my-table transparent-table text-center border-bottom"
                      style={{
                        width: "100%",
                        overflowX: "auto",
                        border: "0px",
                        overflow: "auto",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            colSpan={6}
                            style={{
                              backgroundColor: "#7F8CAA",
                              color: "#ffffff",
                              padding: "16px",
                              textAlign: "center",
                              borderRadius: "12px",
                              fontSize: "15px",
                              fontWeight: "500",
                            }}
                          >
                            Services Summary
                          </th>
                        </tr>
                        <tr
                          className="borderless-table text-center border-bottom"
                          style={{ backgroundColor: "#f8f9fc" }}
                        >
                          <th
                            className="my-table transparent-table text-center border-bottom "
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              backgroundColor: "#f8f9fc",
                              borderRadius: "8px 0 0 8px",
                            }}
                          >
                            Service
                          </th>
                          <th
                            className="my-table transparent-table text-center border-bottom "
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              backgroundColor: "#f8f9fc",
                              borderRadius: "8px 0 0 8px",
                            }}
                          >
                            Success Amt
                          </th>
                          <th
                            className="my-table transparent-table text-center border-bottom "
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              backgroundColor: "#f8f9fc",
                              borderRadius: "8px 0 0 8px",
                            }}
                          >
                            Credit
                          </th>
                          <th
                            className="my-table transparent-table text-center border-bottom "
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              backgroundColor: "#f8f9fc",
                              borderRadius: "8px 0 0 8px",
                            }}
                          >
                            Debit
                          </th>

                          <th
                            className="my-table transparent-table text-center border-bottom "
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              backgroundColor: "#f8f9fc",
                              borderRadius: "8px 0 0 8px",
                            }}
                          >
                            Commission
                          </th>
                          <th
                            className="my-table transparent-table text-center border-bottom "
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              backgroundColor: "#f8f9fc",
                              borderRadius: "8px 0 0 8px",
                            }}
                          >
                            Charges
                          </th>

                          <th
                            className="my-table transparent-table text-center border-bottom "
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              backgroundColor: "#f8f9fc",
                              borderRadius: "8px 0 0 8px",
                            }}
                          >
                            Refund
                          </th>
                          <th
                            className="my-table transparent-table text-center border-bottom "
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              backgroundColor: "#f8f9fc",
                              borderRadius: "8px 0 0 8px",
                            }}
                          >
                            Difference
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {serviceData.map((e, index) => (
                          <tr
                            key={index}
                            className="border-bottom clickable-row"
                          >
                            <td
                              className="text-center border-bottom"
                              style={{
                                fontSize: "0.8rem",
                                fontFamily: "Poppins",
                                fontWeight: "400",
                                lineHeight: "24px",
                                letterSpacing: "0em",
                                textAlign: "center",
                              }}
                            >
                              {e.service}
                            </td>
                            <td
                              className="text-center border-bottom"
                              style={{
                                fontSize: "0.8rem",
                                fontFamily: "Poppins",
                                fontWeight: "400",
                                lineHeight: "24px",
                                letterSpacing: "0em",
                                textAlign: "center",
                                color: e.type == "1" ? "#27ae60" : "#000",
                              }}
                            >
                              ₹{twoDecimalPlaces(e.success_amount)}
                            </td>
                            <td
                              className="text-center border-bottom"
                              style={{
                                fontSize: "0.8rem",
                                fontFamily: "Poppins",
                                fontWeight: "400",
                                lineHeight: "24px",
                                letterSpacing: "0em",
                                textAlign: "center",
                                color: "#27ae60",
                              }}
                            >
                              {e.credit > 0 ? twoDecimalPlaces(e.ledgerViewAmount) : twoDecimalPlaces(e.credit)}
                            </td>

                            <td
                              className="text-center border-bottom"
                              style={{
                                fontSize: "0.8rem",
                                fontFamily: "Poppins",
                                fontWeight: "400",
                                lineHeight: "24px",
                                letterSpacing: "0em",
                                textAlign: "center",
                                color: "#c0392b",
                              }}
                            >
                              {e.debit > 0 ? twoDecimalPlaces(e.ledgerViewAmount) : twoDecimalPlaces(e.debit)}
                            </td>

                            <td
                              className="text-center border-bottom"
   style={{
                                fontSize: "0.8rem",
                                fontFamily: "Poppins",
                                fontWeight: "400",
                                lineHeight: "24px",
                                letterSpacing: "0em",
                                textAlign: "center",
                                color: "#27ae60",
                              }}

                            >
                              {twoDecimalPlaces(e.commission)}
                            </td>

                            <td
                              className="text-center border-bottom"
                              style={{
                                fontSize: "0.8rem",
                                fontFamily: "Poppins",
                                fontWeight: "400",
                                lineHeight: "24px",
                                letterSpacing: "0em",
                                textAlign: "center",
                                color: "#c0392b",
                              }}
                            >
                              {twoDecimalPlaces(e.charges)}
                            </td>

                            <td
                              className="text-center border-bottom"
                              style={{
                                fontSize: "0.8rem",
                                fontFamily: "Poppins",
                                fontWeight: "400",
                                lineHeight: "24px",
                                letterSpacing: "0em",
                                textAlign: "center",
                                color: "#c0392b",
                              }}
                            >
                              ₹{twoDecimalPlaces(e.refund_amount)}
                            </td>
                            <td
                              className="text-center border-bottom"
                              style={{
                                fontSize: "0.8rem",
                                fontFamily: "Poppins",
                                fontWeight: "400",
                                lineHeight: "24px",
                                letterSpacing: "0em",
                                textAlign: "center",
                                color: (e.difference) < 0 ? "#c0392b" : "#27ae60",
                              }}
                            >
                              ₹{twoDecimalPlaces(e.difference)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div class="customers-panel">
            <div
              className="col-12"
              style={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "24px",
                boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.05)",
              }}
            >
              {dataToDisplay.length > 0 && (
                <div className=" scroll-inner admin-fix-width borderless-table ">
                  <table
                    className="my-table transparent-table text-center border-bottom"
                    style={{
                      width: "100%",
                      overflowX: "auto",
                      border: "0px",
                      overflow: "auto",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          colSpan={3}
                          style={{
                            backgroundColor: "#7F8CAA",
                            color: "#ffffff",
                            padding: "16px",
                            textAlign: "center",
                            borderRadius: "12px",
                            fontSize: "15px",
                            fontWeight: "500",
                          }}
                        >
                          Wallet Summary
                        </th>
                      </tr>
                      <tr
                        className="borderless-table text-center border-bottom"
                        style={{ backgroundColor: "#f8f9fc" }}
                      >
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                            borderRadius: "8px 0 0 8px",
                          }}
                        >
                          Service
                        </th>
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                          }}
                        >
                          Credit
                        </th>
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                            borderRadius: "0 8px 8px 0",
                          }}
                        >
                          Debit
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataToDisplay.map((e, index) => (
                        <tr key={index} className="border-bottom clickable-row">
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                            }}
                          >
                            {e.service}
                          </td>
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              color: "#27ae60",
                            }}
                          >
                            ₹{twoDecimalPlaces(e.credit)}
                          </td>
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              color: "#c0392b",
                            }}
                          >
                            ₹{twoDecimalPlaces(e.debit)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="card m-3 p-3">
          <div className="row m-0 p-0  pt-1 align-items-center">
            <div className="col-3 m-0 p-0">
              <div
                className="m-0 p-0 pl-3 align-top"
                style={{
                  fontFamily: "Poppins",
                  fontWeight: "600",
                  lineHeight: "48px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  padding: "0px",
                  background: "#FFFFFF",
                  color: "#0E2148",
                  fontWeight: "bolder",
                  fontfamily: "Poppins !impotent",
                  fontSize: "28px",
                }}
              >
                Duplicate Entries
              </div>
            </div>

            <div className="col-9 m-0 p-0 ">
              <div className="row m-0 p-0 justify-content-end">
                <div
                  className="pr-1 pl-2 p-0 m-0"
                  style={{ width: "18%", height: "20%" }}
                >
                  <Form.Group className="p-0 m-0">
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      className="form-control rounded-100"
                      placeholderText="Start Date"
                    />
                  </Form.Group>
                </div>
                <div
                  className="px-1 p-0 m-0"
                  style={{ width: "18%", height: "20%" }}
                >
                  <Form.Group className="p-0 m-0">
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      className="form-control rounded-100"
                      placeholderText="End Date"
                    />
                  </Form.Group>
                </div>

                <div
                  className="pl-1 p-0 m-0"
                  style={{ width: "20%", height: "20%" }}
                >
                  <Form.Group className="mt-0 p-0 m-0">
                    <Button
                      className=" btn btn-lg btn-block "
                      style={{
                        background: "#0E2148",
                        color: "white",
                      }}
                      onClick={fetchData}
                    >
                      {"Search"}
                    </Button>
                  </Form.Group>
                </div>

                <div
                  className="m-0 p-0 hover-container"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    ExportToExcel(`CMS_REPORT_${now()}`, excelMapping(data));
                  }}
                >
                  <img
                    className="pl-1 p-0"
                    src={require("../../../assets/images/download Icon.png")}
                    style={{ width: `3.5rem`, height: "85%" }}
                  />
                  <div style={positionStyle1} className="hover-text bg-dark ">
                    Export to Excel
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr className="m-0 p-0" />

          <div style={{ width: "100%" }}>
            <div style={{ alignItems: "center" }}>
              <div style={{ flex: "1" }}></div>
            </div>
          </div>
          <div style={{ width: "100%", overflowX: "auto", border: "0px" }}>
            <table
              className="my-table transparent-table text-center border-bottom"
              style={{ width: "100%", overflowX: "auto", border: "0px" }}
            >
              <tr className="borderless-table text-center border-bottom">
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"Sr"}
                </th>

                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  User Code
                </th>
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  Reference
                </th>
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  Count
                </th>
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  Transaction
                </th>

                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  Comment
                </th>

                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  Date
                </th>
              </tr>

              {duplicateEntries.length == 0 && <div>No Data Found</div>}

              {duplicateEntries.map((e, ind) => (
                <tr className="border-bottom clickable-row">
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    {" "}
                    {ind + 1}
                  </td>

                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>{e.us_code}</div>
                  </td>
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>{e.pay_reference}</div>
                  </td>
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>{e.ref_count}</div>
                  </td>
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>Amount :{twoDecimalPlaces(e.pay_balance)}</div>
                    <div>Opening :{twoDecimalPlaces(e.pay_before_balance)}</div>
                    <div>Closing :{twoDecimalPlaces(e.pay_after_balance)}</div>
                  </td>
                  <td
                    className="text-center  text-bold border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>{e.pay_user_comment}</div>
                  </td>
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    {e.pay_indate}
                  </td>
                </tr>
              ))}
            </table>
          </div>

          <Pagination
            page={currentPage}
            limit={pages}
            callback={(page) => {
              setCurrentPage(page);
            }}
            count={dataToDisplay.length}
            total={total}
            callback2={(offsetValue) => {
              setOffset(offsetValue);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ReconDashboard;

export const Pagination = ({
  page,
  limit,
  callback,
  total,
  count,
  callback2,
}) => {
  console.table({ page, limit, callback });
  const selectStyleLeftBorder = {
    borderRadius: "0px",
    fontFamily: "Poppins",
    fontsize: "16px",
    borderRight: "1px solid rgba(0, 0, 0, 0.2)",
    borderRadius: "0px",
    borderLeft: "none",
    borderTop: "none",
    borderBottom: "none",
    fontFamily: "Poppins",
    fontsize: "16px",
  };
  const selectStyleBorder = {
    border: "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    fontFamily: "Poppins",
    fontsize: "16px",
  };
  const selectStyle = {
    border: "none",
    fontFamily: "Poppins",
    fontsize: "16px",
  };
  return (
    <div
      className="row"
      style={{
        display: "flex",
        alignItems: "end",
        width: "100%",
        margin: "12px 0px",
        justifyContent: "space-between",
      }}
    >
      <div style={{ fontFamily: "Poppins" }}>
        <strong>{`Showing ${count} of ${total} entries`}</strong>
      </div>

      <div className="d-flex btn-group p-1" style={selectStyleBorder}>
        <select
          style={selectStyleLeftBorder}
          className=" d-flex justify-content-end "
          aria-label="offset"
          onChange={(e) => {
            callback2(e.target.value);
          }}
        >
          {offsetArr.map((offset) => (
            <option value={offset} className="d-flex justify-content-end">
              {offset}
            </option>
          ))}
        </select>
        {page - 2 > 0 ? (
          <Button
            onClick={() => {
              callback(page - 1);
            }}
            className="rounded-0 bg-white text-dark border-white"
          >
            {"<<"}
          </Button>
        ) : null}

        {page - 1 > 0 ? (
          <Button
            onClick={() => {
              callback(page - 1);
            }}
            className="rounded-0 bg-white text-dark border-white underline-text"
          >
            {" "}
            {(page - 1).toString()}
          </Button>
        ) : null}

        <Button className="bg-white text-primary " style={selectStyle}>
          {" "}
          {page.toString()}
        </Button>
        {page + 1 <= limit ? (
          <Button
            onClick={() => {
              callback(page + 1);
            }}
            className="rounded-0 bg-white text-dark border-white"
          >
            {">>"}
          </Button>
        ) : null}
      </div>
    </div>
  );
};
